module.exports = __webpack_public_path__ + "media/widgets/join-fastweb-for-free-5189f1ee.png";